import create from 'zustand'

interface LoadsCombinedState {
  setLoadsCombined: (loadsCombined: boolean) => void
  loadsCombined: boolean
}

const useLoadsCombinedStore = create<LoadsCombinedState>(set => ({
  setLoadsCombined: (loadsCombined: boolean) => set({ loadsCombined: loadsCombined }),
  loadsCombined: true,
}))

export default useLoadsCombinedStore
